import { isFunction } from './assertions.es.js';

const assignRef = (ref, value) => {
  if (!ref) {
    return;
  }
  if (isFunction(ref)) {
    ref(value);
    return;
  }
  try {
    ref.current = value;
  } catch (error) {
    throw new Error(`Cannot assign value '${value}' to ref '${ref}'`);
  }
};
const mergeRefs = (...refs) => (value) => {
  refs.forEach((ref) => assignRef(ref, value));
};

export { assignRef, mergeRefs };
//# sourceMappingURL=refs.es.js.map
